import React, { useState } from "react";
import { Inertia } from "@inertiajs/inertia";
import AppLayout from "@/Layouts/AppLayout";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import { Tab, Tabs } from "@/Components/Tabs";
import { Dropdown, EmptyState, Subheader } from "@/Components";
import queryString from "query-string";
import { IconConnections } from "@/Icons";
import LayoutIcon from "@/Components/LayoutIcon";
import { Briefcase } from "react-feather";
import { usePage } from "@inertiajs/inertia-react";
import { ClientCard } from "@/Pages/Agency/Clients/Partials/ClientCard";

export default function Index({ organizations = {} }) {
  const favoriteIds =
    usePage().props?.auth?.user?.data?.meta?.favorite_organizations || [];

  const currentSort =
    queryString.parse(window.location.search).sort || "name.asc";

  const [sort, setSort] = useState(currentSort);

  const handleSort = (value) => {
    setSort(value);
    const newSearch = queryString.stringify({
      ...queryString.parse(window.location.search),
      sort: value,
    });
    Inertia.visit(`${window.location.pathname}?${newSearch}`);
  };

  let tabs = ["Active", "Inactive"];

  let activeTeams = organizations.data.filter(
    (organization) => !organization.locked_at,
  );
  let inactivatedOrganizations = organizations.data.filter(
    (organization) => organization.locked_at,
  );

  const sortOptions = [
    { value: "name.asc", label: "Name A-Ö" },
    { value: "name.desc", label: "Name Ö-A" },
  ];

  const OrganizationGrid = ({
    organizations,
    isFavorite,
    emptyState = true,
  }) => {
    const sortedOrganizations = organizations.sort((a, b) => {
      const [sortKey, sortDirection] = sort.split(".");
      if (a[sortKey] < b[sortKey]) {
        return sortDirection === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return sortDirection === "asc" ? 1 : -1;
      }
      return 0;
    });

    if (emptyState && sortedOrganizations.length === 0) {
      return (
        <EmptyState
          title="You have no clients yet"
          text='Get started by clicking "New client" below.'
          buttonText="New client"
          buttonRoute={route("agency.clients.create")}
        />
      );
    }

    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4">
        {sortedOrganizations
          .filter((o) => (isFavorite ? favoriteIds.includes(o.id) : true))
          .map((organization) => (
            <ClientCard
              key={organization.id}
              organization={organization}
              favoriteIds={favoriteIds}
            />
          ))}
      </div>
    );
  };

  return (
    <div className="mb-8">
      <Tabs items={tabs}>
        <Tab>
          <OrganizationGrid
            organizations={activeTeams}
            isFavorite={true}
            emptyState={false}
          />
          <div className="mb-2 flex items-end justify-between gap-4">
            <Subheader margin="" className="mt-12">
              All clients
            </Subheader>
            <Dropdown
              options={sortOptions}
              title="Sort on"
              placeholder={
                sortOptions.find((o) => o.value === sort)?.label || "Name A-Ö"
              }
              onSelect={(value) => {
                handleSort(value);
              }}
            />
          </div>
          <OrganizationGrid organizations={activeTeams} isFavorite={false} />
        </Tab>

        <Tab>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4">
            {inactivatedOrganizations.map((organization) => (
              <ClientCard key={organization.id} organization={organization} />
            ))}
          </div>
        </Tab>
      </Tabs>
    </div>
  );
}

Index.layout = (page) => (
  <AppLayout title="Clients">
    <OrganizationLayout
      header="Clients"
      byline="These are your clients, view company information or go directly to their environment."
      action={{
        label: "New client",
        callback: () => Inertia.visit(route("agency.clients.create")),
      }}
      icon={
        <LayoutIcon>
          <IconConnections size={50} className="text-black" />
        </LayoutIcon>
      }
    >
      {page}
    </OrganizationLayout>
  </AppLayout>
);
